const env = { ...process.env, ...window['env'] };

/**
 * Quando `true`, o formulário inicial não executa o reCAPTCHA nem chama `POST /recaptcha/verify`.
 * Útil em desenvolvimento local se o BFF aceitar o fluxo sem token — definir em `.env`, não em produção.
 */
export const SKIP_RECAPTCHA_VERIFY =
  String(env.REACT_APP_SKIP_RECAPTCHA ?? '').toLowerCase() === 'true';

const rawBase = env.REACT_APP_API_BASE_URL;
/** Base do BFF: rotas em `routes.ts` estão sob `/api/*`; axios usa paths como `/recaptcha/verify`. */
const fallbackBase = 'http://localhost:3001/api';

const trimmed =
  typeof rawBase === 'string' && rawBase.trim() !== '' ? rawBase.replace(/\/+$/, '') : fallbackBase;

/** Garante sufixo `/api` quando a env só traz protocolo/host/porta (evita hits em `/recaptcha/*` sem match no Express). */
export const API_BASE_URL = /\/api$/i.test(trimmed) ? trimmed : `${trimmed}/api`;
